import InputForm from "@ui/Input";
import Form from "@modules/Form";
import viewStates from "@data/viewStates";
import { usePostHog } from "@posthog/react";
import { useAppStore } from "@src/store";
import styles from "@styles/View.module.css";
import { type FC, lazy, Suspense } from "react";
import { AiFillHome as HomeIcon } from "react-icons/ai";
import Button from "@ui/Button";

const Troubleshoot = lazy(() => import("@blocks/Troubleshoot"));

const Default: FC<TDefaultProps> = ({
  Icon,
  title,
  body,
  showInput,
  showLostCode,
  showGoHome = false,
  showTroubleshoot,
}) => {
  const posthog = usePostHog();
  const hasError = useAppStore((state) => state.error);

  const handleGoHome = () => {
    posthog?.capture("go_home_clicked");
    window.location.href = "/";
  };

  return (
    <div
      className={`${styles.loginView} mx-auto mt-6 flex w-full max-w-150 flex-col items-center`}
      data-error={hasError}
    >
      <div className="mb-8 flex w-full items-center justify-center">
        <img
          src="https://www.blazersdev.com/assets/logos/ripcity-rewards_logo.svg"
          alt="Rip City Rewards Logo"
          draggable={false}
          width={320}
          height={116}
          className="aspect-[80/29] h-auto w-full max-w-70 md:max-w-80"
        />
      </div>

      <div className="w-full max-w-360 rounded-xl bg-white px-6 py-8 shadow-[var(--shadow-xl)]">
        <div className="flex flex-col items-center text-center">
          {hasError ? (
            <viewStates.invalid.Icon className={`${styles.icon} block`} />
          ) : Icon ? (
            <Icon className={`${styles.icon} block`} />
          ) : null}
          <h2 className={styles.title}>{hasError ? viewStates.invalid.title : title}</h2>
          {hasError && <div className={styles.body}>{viewStates.invalid.body}</div>}
          {body && <div dangerouslySetInnerHTML={{ __html: body }} className={styles.body} />}
        </div>

        {showInput ? <InputForm /> : null}

        {showTroubleshoot ? (
          <Suspense fallback={null}>
            <Troubleshoot />
          </Suspense>
        ) : null}

        {showGoHome ? (
          <Button
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: ".5em",
              marginBlockStart: "15px",
              maxWidth: "250px",
              marginInline: "auto",
            }}
            onClick={() => handleGoHome()}
          >
            Go Home <HomeIcon />
          </Button>
        ) : null}
      </div>

      {showLostCode ? (
        <div className="w-full max-w-360">
          <Form />
        </div>
      ) : null}
    </div>
  );
};

export default Default;
